/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Reflex API
 * OpenAPI spec version: 1.0.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  UpdateMyPreferencesBody
} from './model/updateMyPreferencesBody.js';

import type {
  UserPreferences
} from './model/userPreferences.js';

import { apiFetch } from '../react-mutator.js';



type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

/**
 * @summary Dismiss the onboarding banner.
 */
export const dismissOnboardingBanner = (

 options?: SecondParameter<typeof apiFetch>,signal?: AbortSignal
) => {


      return apiFetch<void>(
      {url: `/user/onboarding/banner/dismiss`, method: 'POST', signal
    },
      options);
    }




export const getDismissOnboardingBannerMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof dismissOnboardingBanner>>, TError,void, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof dismissOnboardingBanner>>, TError,void, TContext> => {

const mutationKey = ['dismissOnboardingBanner'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof dismissOnboardingBanner>>, void> = () => {


          return  dismissOnboardingBanner(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DismissOnboardingBannerMutationResult = NonNullable<Awaited<ReturnType<typeof dismissOnboardingBanner>>>

    export type DismissOnboardingBannerMutationError = unknown

    /**
 * @summary Dismiss the onboarding banner.
 */
export const useDismissOnboardingBanner = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof dismissOnboardingBanner>>, TError,void, TContext>, request?: SecondParameter<typeof apiFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof dismissOnboardingBanner>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getDismissOnboardingBannerMutationOptions(options));
    }
    /**
 * @summary Get the current user's onboarding state.
 */
export const getOnboardingState = (

 options?: SecondParameter<typeof apiFetch>,signal?: AbortSignal
) => {


      return apiFetch<void>(
      {url: `/user/onboarding/state`, method: 'GET', signal
    },
      options);
    }




export const getGetOnboardingStateQueryKey = () => {
    return [
    `/user/onboarding/state`
    ] as const;
    }


export const getGetOnboardingStateQueryOptions = <TData = Awaited<ReturnType<typeof getOnboardingState>>, TError = unknown>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getOnboardingState>>, TError, TData>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetOnboardingStateQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getOnboardingState>>> = ({ signal }) => getOnboardingState(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getOnboardingState>>, TError, TData> & { queryKey: QueryKey }
}

export type GetOnboardingStateQueryResult = NonNullable<Awaited<ReturnType<typeof getOnboardingState>>>
export type GetOnboardingStateQueryError = unknown


/**
 * @summary Get the current user's onboarding state.
 */

export function useGetOnboardingState<TData = Awaited<ReturnType<typeof getOnboardingState>>, TError = unknown>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getOnboardingState>>, TError, TData>, request?: SecondParameter<typeof apiFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetOnboardingStateQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary Skip an onboarding step and return the updated state.
 */
export const skipOnboardingStep = (
    stepId: string,
 options?: SecondParameter<typeof apiFetch>,signal?: AbortSignal
) => {


      return apiFetch<void>(
      {url: `/user/onboarding/steps/${encodeURIComponent(String(stepId))}/skip`, method: 'POST', signal
    },
      options);
    }




export const getSkipOnboardingStepMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof skipOnboardingStep>>, TError,{stepId: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof skipOnboardingStep>>, TError,{stepId: string}, TContext> => {

const mutationKey = ['skipOnboardingStep'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof skipOnboardingStep>>, {stepId: string}> = (props) => {
          const {stepId} = props ?? {};

          return  skipOnboardingStep(stepId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SkipOnboardingStepMutationResult = NonNullable<Awaited<ReturnType<typeof skipOnboardingStep>>>

    export type SkipOnboardingStepMutationError = unknown

    /**
 * @summary Skip an onboarding step and return the updated state.
 */
export const useSkipOnboardingStep = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof skipOnboardingStep>>, TError,{stepId: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof skipOnboardingStep>>,
        TError,
        {stepId: string},
        TContext
      > => {
      return useMutation(getSkipOnboardingStepMutationOptions(options));
    }
    /**
 * @summary Dismiss the onboarding wizard and mark onboarding complete.
 */
export const dismissOnboardingWizard = (

 options?: SecondParameter<typeof apiFetch>,signal?: AbortSignal
) => {


      return apiFetch<void>(
      {url: `/user/onboarding/wizard/dismiss`, method: 'POST', signal
    },
      options);
    }




export const getDismissOnboardingWizardMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof dismissOnboardingWizard>>, TError,void, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof dismissOnboardingWizard>>, TError,void, TContext> => {

const mutationKey = ['dismissOnboardingWizard'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof dismissOnboardingWizard>>, void> = () => {


          return  dismissOnboardingWizard(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DismissOnboardingWizardMutationResult = NonNullable<Awaited<ReturnType<typeof dismissOnboardingWizard>>>

    export type DismissOnboardingWizardMutationError = unknown

    /**
 * @summary Dismiss the onboarding wizard and mark onboarding complete.
 */
export const useDismissOnboardingWizard = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof dismissOnboardingWizard>>, TError,void, TContext>, request?: SecondParameter<typeof apiFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof dismissOnboardingWizard>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getDismissOnboardingWizardMutationOptions(options));
    }
    /**
 * @summary Get the current user's UI preferences.
 */
export const getMyPreferences = (

 options?: SecondParameter<typeof apiFetch>,signal?: AbortSignal
) => {


      return apiFetch<UserPreferences>(
      {url: `/user/preferences`, method: 'GET', signal
    },
      options);
    }




export const getGetMyPreferencesQueryKey = () => {
    return [
    `/user/preferences`
    ] as const;
    }


export const getGetMyPreferencesQueryOptions = <TData = Awaited<ReturnType<typeof getMyPreferences>>, TError = unknown>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getMyPreferences>>, TError, TData>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMyPreferencesQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMyPreferences>>> = ({ signal }) => getMyPreferences(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMyPreferences>>, TError, TData> & { queryKey: QueryKey }
}

export type GetMyPreferencesQueryResult = NonNullable<Awaited<ReturnType<typeof getMyPreferences>>>
export type GetMyPreferencesQueryError = unknown


/**
 * @summary Get the current user's UI preferences.
 */

export function useGetMyPreferences<TData = Awaited<ReturnType<typeof getMyPreferences>>, TError = unknown>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getMyPreferences>>, TError, TData>, request?: SecondParameter<typeof apiFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetMyPreferencesQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary Update the current user's UI preferences.
 */
export const updateMyPreferences = (
    updateMyPreferencesBody: UpdateMyPreferencesBody,
 options?: SecondParameter<typeof apiFetch>,signal?: AbortSignal
) => {


      return apiFetch<UserPreferences>(
      {url: `/user/preferences`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: updateMyPreferencesBody, signal
    },
      options);
    }




export const getUpdateMyPreferencesMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateMyPreferences>>, TError,{data: UpdateMyPreferencesBody}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateMyPreferences>>, TError,{data: UpdateMyPreferencesBody}, TContext> => {

const mutationKey = ['updateMyPreferences'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateMyPreferences>>, {data: UpdateMyPreferencesBody}> = (props) => {
          const {data} = props ?? {};

          return  updateMyPreferences(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateMyPreferencesMutationResult = NonNullable<Awaited<ReturnType<typeof updateMyPreferences>>>
    export type UpdateMyPreferencesMutationBody = UpdateMyPreferencesBody
    export type UpdateMyPreferencesMutationError = unknown

    /**
 * @summary Update the current user's UI preferences.
 */
export const useUpdateMyPreferences = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateMyPreferences>>, TError,{data: UpdateMyPreferencesBody}, TContext>, request?: SecondParameter<typeof apiFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateMyPreferences>>,
        TError,
        {data: UpdateMyPreferencesBody},
        TContext
      > => {
      return useMutation(getUpdateMyPreferencesMutationOptions(options));
    }
    /**
 * @summary List the current user's linked sign-in providers.
 */
export const getMyProviders = (

 options?: SecondParameter<typeof apiFetch>,signal?: AbortSignal
) => {


      return apiFetch<void>(
      {url: `/user/providers`, method: 'GET', signal
    },
      options);
    }




export const getGetMyProvidersQueryKey = () => {
    return [
    `/user/providers`
    ] as const;
    }


export const getGetMyProvidersQueryOptions = <TData = Awaited<ReturnType<typeof getMyProviders>>, TError = unknown>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getMyProviders>>, TError, TData>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMyProvidersQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMyProviders>>> = ({ signal }) => getMyProviders(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMyProviders>>, TError, TData> & { queryKey: QueryKey }
}

export type GetMyProvidersQueryResult = NonNullable<Awaited<ReturnType<typeof getMyProviders>>>
export type GetMyProvidersQueryError = unknown


/**
 * @summary List the current user's linked sign-in providers.
 */

export function useGetMyProviders<TData = Awaited<ReturnType<typeof getMyProviders>>, TError = unknown>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getMyProviders>>, TError, TData>, request?: SecondParameter<typeof apiFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetMyProvidersQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary Unlink a sign-in provider from the current user's account.
 */
export const disconnectMyProvider = (
    provider: string,
 options?: SecondParameter<typeof apiFetch>,signal?: AbortSignal
) => {


      return apiFetch<void>(
      {url: `/user/providers/${encodeURIComponent(String(provider))}`, method: 'DELETE', signal
    },
      options);
    }




export const getDisconnectMyProviderMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof disconnectMyProvider>>, TError,{provider: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof disconnectMyProvider>>, TError,{provider: string}, TContext> => {

const mutationKey = ['disconnectMyProvider'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof disconnectMyProvider>>, {provider: string}> = (props) => {
          const {provider} = props ?? {};

          return  disconnectMyProvider(provider,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DisconnectMyProviderMutationResult = NonNullable<Awaited<ReturnType<typeof disconnectMyProvider>>>

    export type DisconnectMyProviderMutationError = unknown

    /**
 * @summary Unlink a sign-in provider from the current user's account.
 */
export const useDisconnectMyProvider = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof disconnectMyProvider>>, TError,{provider: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof disconnectMyProvider>>,
        TError,
        {provider: string},
        TContext
      > => {
      return useMutation(getDisconnectMyProviderMutationOptions(options));
    }
